import { Autocomplete, Box, Button, Card, Chip, Dialog, DialogActions, DialogContent, Grid, IconButton, TextField, Typography } from '@mui/material';
import { FormikProps, getIn } from 'formik';
import React, { useEffect, useRef, useState } from 'react'
import { ApiCreateCategory, ApiGetCategories, ApiUploadFile } from '../../../../Core/Apicall';
import { toast } from 'react-toastify';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { Add, Close, CloseOutlined, CloudUploadOutlined, Delete } from '@mui/icons-material';
import { Category } from '../../../../types/Category';

interface Props {
    formik: FormikProps<any>;
}
function ProductDetails({ formik }: Props) {
    const [categoryList, setCategoryList] = useState<Category[]>([])
    const [categoryName, setCategoryName] = useState<string>("")
    const [openAdd, setOpenAdd] = useState<boolean>(false)
    const [description, setDescription] = useState<string>("")
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(e.target.files || []);
        console.log('FIles', files)
        // if (!files.length) return;

        try {
            const formData = new FormData();

            files.forEach((file) => {
                formData.append("files", file); // or "files" depending on your backend
            });

            formData.append("folder", "products");

            const res = await ApiUploadFile(formData);

            if (res?.status) {
                const uploadedMedia = res.data.map((item: any) => ({
                    media_url: item.fileUrl,
                    media_type: "IMAGE",
                }));

                formik.setFieldValue("media", [
                    ...formik.values.media,
                    ...uploadedMedia,
                ]);

                // Allow selecting same file again
                e.target.value = "";
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong");
        }
    };

    const getCategoryList = async () => {
        try {
            const res = await ApiGetCategories()
            if (res?.status) {
                setCategoryList(res?.data)
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong")
        }
    }

    useEffect(() => {
        getCategoryList()
    }, [])

    console.log("Formik Values", formik.values)

    const handleCloseAdd = () => {
        setCategoryName("")
        setDescription("")
        setOpenAdd(false)

    }

    const handleAddCategory = async () => {
        try {
            if (!categoryName.trim() || !description.trim()) {
                toast.error("Please enter both category name and description");
                return;
            }
            const data = {
                categoryName: categoryName.trim(),
                description: description.trim()
            }
            const res = await ApiCreateCategory(data)
            if (res?.status) {
                getCategoryList()
                handleCloseAdd()
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong")
        }
    }

    const handleRemoveMedia = (index: number) => {
        const updatedMedia = [...formik.values.media];
        updatedMedia.splice(index, 1);

        formik.setFieldValue("media", updatedMedia);
    };
    return (
        <Box className='p-xl-5 px-xl-4 py-md-3 py-3'>
            <Box className='border-10' sx={{ border: { xs: "none", md: '1px solid #ccc' } }}>
                {/* --------------------------------------- Basic Information-------------------------------------- */}
                <Box className='p-md-3 p-1 mb-2'>
                    <Typography variant='h6' className='fw-bold'>Basic Information</Typography>
                    <hr className='my-1' />
                    <Grid container className='form-text-field' spacing={1.5}>
                        <Grid size={{ xs: 12 }} className='mt-3'>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Product Name</Typography>
                            <TextField
                                name='productName'
                                fullWidth
                                placeholder='Enter product name'
                                value={formik.values.productName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.productName && Boolean(formik.errors.productName)}
                                helperText={
                                    formik.touched.productName
                                        ? (formik.errors.productName as string)
                                        : ""
                                }
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }} className='mt-3'>
                            <Box className='d-flex align-items-center justify-content-between pe-2'>
                                <Typography className='fw-bold input-label' variant='body2' gutterBottom>Category</Typography>
                                <Typography className='text-main pointer' onClick={() => { setOpenAdd(true) }} variant='caption' >+Add New</Typography>
                            </Box>
                            <Autocomplete
                                fullWidth
                                options={categoryList}
                                getOptionLabel={(option) => option.categoryName}
                                value={categoryList.find(option => option.categoryId === formik.values.categoryId) || null}
                                onChange={(_, option) => {
                                    formik.setFieldValue("categoryId", option?.categoryId || "");
                                }}
                                onBlur={() => formik.setFieldTouched("categoryId", true)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Category"
                                        error={
                                            formik.touched.categoryId &&
                                            Boolean(formik.errors.categoryId)
                                        }
                                        helperText={
                                            formik.touched.categoryId
                                                ? (formik.errors.categoryId as string)
                                                : ""
                                        }
                                    />
                                )}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }} className='mt-3'>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Unit Text</Typography>
                            <TextField
                                name='unit_text'
                                fullWidth
                                placeholder='Enter unit text'
                                value={formik.values.unit_text}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.unit_text && Boolean(formik.errors.unit_text)}
                                helperText={
                                    formik.touched.unit_text
                                        ? (formik.errors.unit_text as string)
                                        : ""
                                }
                            />
                        </Grid>
                        <Grid size={{ xs: 12 }} className='mt-3'>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Product Description</Typography>
                            <ReactQuill
                                theme="snow"
                                className="product-editor border-10"
                                value={formik.values.description}
                                // onChange={(value: string) => formik.setFieldValue("description", value)}
                                onChange={(value, delta, source) => {
                                    if (source === "user") {
                                        formik.setFieldValue("description", value);
                                    }
                                }}
                                onBlur={() => formik.setFieldTouched("description", true)}
                                placeholder="Enter product description..."

                                style={{
                                    background: "#fff",
                                }}
                            />

                            {formik.touched.description && formik.errors.description && (
                                <Typography
                                    color="error"
                                    variant="caption"
                                    sx={{ mt: 1, display: "block" }}
                                >
                                    {formik.errors.description as String}
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                </Box>
                {/* --------------------------------------- Product Images-------------------------------------- */}
                <Box className='p-md-3 p-1 mb-2'>
                    <Typography variant='h6' className='fw-bold'>Product Images</Typography>
                    <hr className='my-1' />
                    <Grid container spacing={1.5} className='mt-4'>
                        <Grid size={{ xs: 12, md: 'auto' }}>
                            <Box
                                className='p-4 d-flex flex-column border-10 justify-content-cneter text-center align-items-center'
                                sx={{
                                    border: "2px dashed #d6d6d6",
                                    cursor: 'pointer'
                                }}
                                onClick={() => fileInputRef.current?.click()}
                            >
                                <CloudUploadOutlined sx={{ fontSize: 35, color: "#777" }} />

                                <Typography className='mt-1' variant="body1">
                                    Drag & drop images here
                                </Typography>

                                <Typography className='my-1' variant="body2" color="text.secondary">
                                    or
                                </Typography>

                                <Button variant="outlined" onClick={(e) => {
                                    e.stopPropagation();
                                    fileInputRef.current?.click();
                                }} className='btn-outlined-main my-2' size="small">
                                    Upload Images
                                </Button>

                                <Typography
                                    className='mt-1'
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{ fontSize: 10 }}
                                >
                                    PNG or JPG.Max size 5MB
                                </Typography>

                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    hidden
                                    multiple
                                    accept="image/*"
                                    onChange={handleUpload}
                                />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 'grow' }}>
                            <Box
                                sx={{
                                    flex: 1,
                                    display: "grid",
                                    gridTemplateColumns: {
                                        xs: "repeat(2, 1fr)",
                                        sm: "repeat(3, 1fr)",
                                        md: "repeat(4, 1fr)",
                                    },
                                    gap: 2,
                                }}
                            >
                                {formik.values?.media?.map((item: any, index: number) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            border: "1px solid #e0e0e0",
                                            borderRadius: 2,
                                            overflow: "hidden",
                                            position: "relative",
                                            background: "#fff",
                                            height: 170,
                                        }}
                                    >
                                        {/* Remove Button */}
                                        <IconButton
                                            size="small"
                                            sx={{
                                                position: "absolute",
                                                top: 5,
                                                right: 5,
                                                bgcolor: "#fff",
                                                zIndex: 1,
                                            }}
                                            onClick={() => handleRemoveMedia(index)}
                                        >
                                            <Close fontSize="small" />
                                        </IconButton>

                                        <Box
                                            component="img"
                                            src={item.media_url}
                                            alt={`Product ${index + 1}- ${item?.media_url}`}
                                            sx={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain",
                                                p: 1,
                                            }}
                                        />

                                        {index === 0 && (
                                            <Chip
                                                label="Primary"
                                                color="success"
                                                size="small"
                                                sx={{
                                                    position: "absolute",
                                                    bottom: 8,
                                                    left: "50%",
                                                    transform: "translateX(-50%)",
                                                }}
                                            />
                                        )}
                                    </Box>
                                ))}
                            </Box>
                        </Grid>
                    </Grid>
                    {formik.touched.media && formik.errors.media && (
                        <Typography
                            color="error"
                            variant="caption"
                            sx={{ mt: 1, display: "block" }}
                        >
                            {typeof formik.errors.media === "string"
                                ? formik.errors.media
                                : ""}
                        </Typography>
                    )}

                </Box>


                {/* --------------------------------------- Pricing & Delivery-------------------------------------- */}
                <Box className='p-md-3 p-1 mb-2'>
                    <Typography variant='h6' className='fw-bold'>Pricing & Delivery</Typography>
                    <hr className='my-1' />
                    <Grid container className='form-text-field' spacing={1.5}>
                        <Grid size={{ xs: 12, md: 4 }} className='mt-3'>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Basic Price (INR)</Typography>
                            <TextField
                                name='base_price'
                                type='number'
                                fullWidth
                                placeholder='Enter base price'
                                value={formik.values.base_price}
                                onChange={formik.handleChange}
                                // onBlur={formik.handleBlur}
                                error={formik.touched.base_price && Boolean(formik.errors.base_price)}
                                helperText={
                                    formik.touched.base_price
                                        ? (formik.errors.base_price as string)
                                        : ""
                                }
                                onBlur={(e) => {
                                    formik.handleBlur(e);
                                    const val = Number(e.target.value);
                                    if (e.target.value !== "" && (isNaN(val) || val < 0.01)) {
                                        formik.setFieldValue("base_price", 0.01);
                                    }
                                }}
                                slotProps={{
                                    htmlInput: { min: 0.01, step: 0.01 },
                                }}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }} className='mt-3'>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Discount Percentage (%)</Typography>
                            <TextField
                                name='discount_percentage'
                                type='number'
                                fullWidth
                                placeholder='Enter discount'
                                value={formik.values.discount_percentage}
                                onChange={formik.handleChange}
                                // onBlur={formik.handleBlur}
                                error={formik.touched.discount_percentage && Boolean(formik.errors.discount_percentage)}
                                helperText={
                                    formik.touched.discount_percentage
                                        ? (formik.errors.discount_percentage as string)
                                        : ""
                                }
                                onBlur={(e) => {
                                    formik.handleBlur(e);
                                    if (e.target.value === "") return;
                                    const val = Number(e.target.value);
                                    if (isNaN(val) || val < 0) {
                                        formik.setFieldValue("discount_percentage", 0);
                                    } else if (val > 100) {
                                        formik.setFieldValue("discount_percentage", 100);
                                    }
                                }}
                                slotProps={{
                                    htmlInput: { min: 0, max: 100, step: 0.01 },
                                }}
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }} className='mt-3'>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Discount Price</Typography>
                            <TextField
                                name='discounted_price'
                                fullWidth
                                // placeholder='Enter discount'
                                // value={formik.values.discounted_price}
                                value={Number(formik.values.base_price - (formik.values.discount_percentage * formik.values.base_price) / 100).toFixed(2) || ""}
                                disabled
                            // onChange={formik.handleChange}
                            // onBlur={formik.handleBlur}
                            // error={formik.touched.discount_percentage && Boolean(formik.errors.discount_percentage)}
                            // helperText={
                            // formik.touched.discount_percentage
                            // ? (formik.errors.discount_percentage as string)
                            // : ""
                            // }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }} className='mt-3'>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Min Delivery Days</Typography>
                            <TextField
                                name='min_delivery_days'
                                type='number'
                                fullWidth
                                placeholder='Enter min days'
                                value={formik.values.min_delivery_days}
                                onChange={formik.handleChange}
                                // onBlur={formik.handleBlur}
                                error={formik.touched.min_delivery_days && Boolean(formik.errors.min_delivery_days)}
                                helperText={
                                    formik.touched.min_delivery_days
                                        ? (formik.errors.min_delivery_days as string)
                                        : ""
                                }
                                onBlur={(e) => {
                                    formik.handleBlur(e);
                                    if (e.target.value === "") return;
                                    const val = Number(e.target.value);
                                    if (isNaN(val) || val < 0) {
                                        formik.setFieldValue("min_delivery_days", 0);
                                    } else if (!Number.isInteger(val)) {
                                        formik.setFieldValue("min_delivery_days", Math.round(val));
                                    }
                                }}
                                slotProps={{
                                    htmlInput: { min: 1, step: 1 },
                                }}
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }} className='mt-3'>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Max Delivery Days</Typography>
                            <TextField
                                name='max_delivery_days'
                                fullWidth
                                type='number'
                                placeholder='Enter max days'
                                value={formik.values.max_delivery_days}
                                onChange={formik.handleChange}
                                // onBlur={formik.handleBlur}
                                error={formik.touched.max_delivery_days && Boolean(formik.errors.max_delivery_days)}
                                helperText={
                                    formik.touched.max_delivery_days
                                        ? (formik.errors.max_delivery_days as string)
                                        : ""
                                }
                                onBlur={(e) => {
                                    formik.handleBlur(e);
                                    if (e.target.value === "") return;
                                    const val = Number(e.target.value);
                                    const minDays = Number(formik.values.min_delivery_days) || 0;
                                    if (isNaN(val) || val < minDays) {
                                        formik.setFieldValue("max_delivery_days", minDays);
                                    } else if (!Number.isInteger(val)) {
                                        formik.setFieldValue("max_delivery_days", Math.round(val));
                                    }
                                }}
                                slotProps={{
                                    htmlInput: {
                                        min: Number(formik.values.min_delivery_days) || 0,
                                        step: 1,
                                    },
                                }}
                            />

                        </Grid>
                    </Grid>
                </Box>

                {/* --------------------------------------- Technical and wholesale Details-------------------------------------- */}
                <Grid container spacing={1.5} className='form-text-field p-md-3 p-1'>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Card
                            elevation={0}
                            className='bg-transparent border p-3 border-10'
                        >
                            <Typography variant="h6" className="fw-bold mb-3">
                                Technical Details
                            </Typography>

                            <Grid
                                container
                                className='bg-grey p-2 mb-2'
                            >
                                <Grid size={{ xs: 'grow' }}>Key</Grid>
                                <Grid size={{ xs: 'grow' }}>Value</Grid>
                                <Grid size={{ xs: 1 }}></Grid>
                            </Grid>

                            {formik.values.technicalDetails.map((item: any, index: number) => (
                                <Grid
                                    container
                                    spacing={1}
                                    key={index}
                                    className="mb-2 align-items-center"
                                >
                                    <Grid size={{ xs: 'grow' }}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            placeholder="Key"
                                            name={`technicalDetails.${index}.key`}
                                            value={item.key}
                                            onChange={formik.handleChange}
                                            error={Boolean(
                                                getIn(formik.touched, `technicalDetails.${index}.key`) &&
                                                getIn(formik.errors, `technicalDetails.${index}.key`)
                                            )}
                                            helperText={
                                                getIn(formik.touched, `technicalDetails.${index}.key`)
                                                    ? getIn(formik.errors, `technicalDetails.${index}.key`)
                                                    : ""
                                            }
                                        />
                                    </Grid>

                                    <Grid size={{ xs: 'grow' }}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            placeholder="Value"
                                            name={`technicalDetails.${index}.value`}
                                            value={item.value}
                                            onChange={formik.handleChange}
                                            error={Boolean(
                                                getIn(formik.touched, `technicalDetails.${index}.value`) &&
                                                getIn(formik.errors, `technicalDetails.${index}.value`)
                                            )}
                                            helperText={
                                                getIn(formik.touched, `technicalDetails.${index}.value`)
                                                    ? getIn(formik.errors, `technicalDetails.${index}.value`)
                                                    : ""
                                            }
                                        />
                                    </Grid>

                                    <Grid size={{ xs: 1 }} className='text-center'>
                                        <IconButton
                                            color="error"
                                            disabled={formik.values.technicalDetails.length === 1}
                                            onClick={() => {
                                                const data = [...formik.values.technicalDetails];
                                                data.splice(index, 1);
                                                formik.setFieldValue("technicalDetails", data);
                                            }}
                                        >
                                            <Delete fontSize="small" />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            ))}

                            <Button
                                startIcon={<Add />}
                                variant="outlined"
                                className='btn-outlined-main'
                                sx={{ mt: 1 }}
                                onClick={() =>
                                    formik.setFieldValue("technicalDetails", [
                                        ...formik.values.technicalDetails,
                                        { key: "", value: "" },
                                    ])
                                }
                            >
                                Add Technical Detail
                            </Button>
                        </Card>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Card
                            elevation={0}
                            className='bg-transparent border border-10 p-3'
                        >
                            <Typography variant="h6" className="fw-bold mb-3">
                                Wholesale Price Tiers
                            </Typography>

                            <Grid
                                container
                                className='bg-grey p-2 mb-2'
                            >
                                <Grid size='grow'>Min Quantity</Grid>
                                <Grid size='grow'>Price (₹)</Grid>
                                <Grid size={1}></Grid>
                            </Grid>

                            {formik.values.wholesalePriceTiers.map(
                                (item: any, index: number) => (
                                    <Grid
                                        container
                                        spacing={1}
                                        key={index}
                                        className="mb-2 align-items-center"
                                    >
                                        <Grid size='grow'>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                type="number"
                                                placeholder="Min Qty"
                                                name={`wholesalePriceTiers.${index}.min_quantity`}
                                                value={item.min_quantity}
                                                onChange={formik.handleChange}
                                                onBlur={(e) => {
                                                    formik.handleBlur(e);
                                                    const val = Number(e.target.value);
                                                    if (e.target.value !== "" && (isNaN(val) || val < 1)) {
                                                        formik.setFieldValue(`wholesalePriceTiers.${index}.min_quantity`, 1);
                                                    }
                                                }}
                                                slotProps={{
                                                    htmlInput: { min: 1, step: 1 },
                                                }}
                                                helperText={
                                                    getIn(formik.touched, `wholesalePriceTiers.${index}.min_quantity`)
                                                        ? getIn(formik.errors, `wholesalePriceTiers.${index}.min_quantity`)
                                                        : ""
                                                }
                                            />
                                        </Grid>

                                        <Grid size='grow'>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                type="number"
                                                placeholder="Price"
                                                name={`wholesalePriceTiers.${index}.price`}
                                                value={item.price}
                                                onChange={formik.handleChange}
                                                onBlur={(e) => {
                                                    formik.handleBlur(e);
                                                    const val = Number(e.target.value);
                                                    if (e.target.value !== "" && (isNaN(val) || val < 0.01)) {
                                                        formik.setFieldValue(`wholesalePriceTiers.${index}.price`, 0.01);
                                                    }
                                                }}
                                                slotProps={{
                                                    htmlInput: { min: 0.01, step: 0.01 },
                                                }}
                                                error={Boolean(
                                                    getIn(formik.touched, `wholesalePriceTiers.${index}.price`) &&
                                                    getIn(formik.errors, `wholesalePriceTiers.${index}.price`)
                                                )}
                                                helperText={
                                                    getIn(formik.touched, `wholesalePriceTiers.${index}.price`)
                                                        ? getIn(formik.errors, `wholesalePriceTiers.${index}.price`)
                                                        : ""
                                                }
                                            />
                                        </Grid>

                                        <Grid size={{ xs: 1 }} className='text-center'>
                                            <IconButton
                                                color="error"
                                                disabled={formik.values.wholesalePriceTiers.length === 1}
                                                onClick={() => {
                                                    const data = [
                                                        ...formik.values.wholesalePriceTiers,
                                                    ];
                                                    data.splice(index, 1);
                                                    formik.setFieldValue(
                                                        "wholesalePriceTiers",
                                                        data
                                                    );
                                                }}
                                            >
                                                <Delete fontSize="small" />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                )
                            )}

                            <Button
                                startIcon={<Add />}
                                variant="outlined"
                                className='btn-outlined-main'
                                sx={{ mt: 1 }}
                                onClick={() =>
                                    formik.setFieldValue("wholesalePriceTiers", [
                                        ...formik.values.wholesalePriceTiers,
                                        {
                                            min_quantity: "",
                                            price: "",
                                        },
                                    ])
                                }
                            >
                                Add Tier
                            </Button>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
            <Dialog
                open={openAdd}
                maxWidth="sm"
                fullWidth
                slotProps={{
                    paper: {
                        sx: {
                            width: 480,
                            borderRadius: '10px',
                            p: 1,
                        },
                    },
                }}
            >
                <DialogContent sx={{ p: 2 }}>
                    {/* Header */}
                    <Box className='d-flex align-items-center justify-content-between mb-3'
                    >
                        <Typography variant="h6" className='fw-bold'>
                            Add Category
                        </Typography>

                        <IconButton size="small" onClick={() => { handleCloseAdd() }}>
                            <CloseOutlined />
                        </IconButton>
                    </Box>

                    {/* Category Name */}
                    <Box className='mb-3'>
                        <Typography
                            variant="body2"
                            className='fw-bold mb-1'
                        >
                            Category Name <span style={{ color: "red" }}>*</span>
                        </Typography>

                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Enter category name"
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                        />
                    </Box>

                    {/* Description */}
                    <Box className='mb-3'>
                        <Typography
                            variant="body2"
                            className='fw-bold mb-1'
                        >
                            Description <span style={{ color: "red" }}>*</span>
                        </Typography>

                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            placeholder="Enter category description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </Box>

                    {/* Buttons */}
                    <Box
                        className='d-flex justify-content-end gap-2'
                    >
                        <Button
                            variant="outlined"
                            className='btn-outlined-main'
                            onClick={() => { handleCloseAdd() }}
                        >
                            Cancel
                        </Button>

                        <Button
                            className='btn-main'
                            onClick={() => { handleAddCategory() }}
                        >
                            Save
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </Box>
    )
}

export default ProductDetails
